// facebook-auth.service.ts
import { Injectable } from '@angular/core';
import { AuthRsocialService } from './auth-rsocial.service';

declare const FB: any;

@Injectable({
    providedIn: 'root'
})
export class FacebookAuthService {
    private isScriptLoaded = false;
    private isInitialized = false;

    constructor(private authService: AuthRsocialService) { }

    // Vérifier si le script Facebook est déjà chargé
    private isFacebookScriptLoaded(): boolean {
        return typeof window !== 'undefined' && typeof (window as any).FB !== 'undefined';
    }

    // Injecter le script Facebook dynamiquement
    private loadFacebookScript(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            if (this.isFacebookScriptLoaded()) {
                console.log('Facebook script déjà chargé');
                resolve(true);
                return;
            }

            const existingScript = document.querySelector('script[src*="connect.facebook.net"]') as HTMLScriptElement;
            if (existingScript) {
                console.log('Facebook script en cours de chargement...');
                existingScript.onload = () => resolve(true);
                existingScript.onerror = () => reject(new Error('Erreur de chargement du script Facebook'));
                return;
            }

            const script = document.createElement('script');
            script.src = 'https://connect.facebook.net/fr_FR/sdk.js';
            script.async = true;
            script.defer = true;

            script.onload = () => {
                console.log('Facebook script chargé avec succès');
                this.isScriptLoaded = true;
                resolve(true);
            };

            script.onerror = () => {
                console.error('Erreur lors du chargement du script Facebook');
                reject(new Error('Impossible de charger le script Facebook'));
            };

            document.head.appendChild(script);
        });
    }

    // Initialiser Facebook SDK
    async initialize(appId: string): Promise<void> {
        try {
            await this.loadFacebookScript();

            FB.init({
                appId: appId,
                cookie: true,
                xfbml: true,
                version: 'v18.0'
            });

            this.isInitialized = true;
            console.log('Facebook SDK initialisé');

        } catch (error) {
            console.error('Erreur lors de l\'initialisation Facebook:', error);
            throw error;
        }
    }

    // Se connecter avec Facebook
    login(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (!this.isInitialized) {
                reject(new Error('Facebook SDK non initialisé'));
                return;
            }

            FB.login((response: any) => {
                if (response.authResponse) {
                    // Récupérer les infos utilisateur
                    FB.api('/me', { fields: 'first_name,last_name,email' }, (userInfo: any) => {
                        this.authService.handleFacebookResponse(userInfo);
                        resolve(userInfo);
                    });
                } else {
                    reject(new Error('Connexion Facebook annulée'));
                }
            }, { scope: 'email' });
        });
    }

    // Se déconnecter
    logout(): void {
        if (this.isFacebookScriptLoaded()) {
            FB.logout();
        }
        this.authService.logout();
    }
}